import {createAction, handleActions} from 'redux-actions';
import {Api} from "../../api/api";
import {logout, onForbidden} from '../account/login';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from "../common/submitForm";
import {ASSISTANT_TYPES} from "../../constants/constants";

//- Actions
export const fetchGetAssistantsFailed = createAction('FETCH_GET_ASSISTANTS_FAILED');
export const fetchGetAssistantsSuccess = createAction('FETCH_GET_ASSISTANTS_SUCCESS');
export const fetchGetAssistants = createAction(
    'FETCH_GET_ASSISTANTS',
    () => Api.getAssistants(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAssistantsSuccess,
        onFail: fetchGetAssistantsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onCreateAssistant = (data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchCreateAssistant(data));
};

export const fetchCreateAssistant = createAction(
    'FETCH_ADD_ASSISTANT',
    (data) => Api.addAssistant(data),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);


export const onRemoveAssistant = (id) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchRemoveAssistant(id));
};

export const fetchRemoveAssistantSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(fetchGetAssistants())
};

export const fetchRemoveAssistant = createAction(
    'FETCH_REMOVE_ASSISTANT',
    (id) => Api.removeAssistant(id),
    () => ({
        apiCall: true,
        onSuccess: fetchRemoveAssistantSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onEditAssistant = (id, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchEditAssistant(id, data));
};

export const fetchEditAssistantSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(fetchGetAssistants());
};

export const fetchEditAssistant = createAction(
    'FETCH_EDIT_ASSISTANT',
    (id, data) => Api.editAssistant(id, data),
    () => ({
        apiCall: true,
        onSuccess: fetchEditAssistantSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);


//- State
const initialState = {
    fetching: false,
    data: null,
    error: null
};

//- Reducers
export default handleActions({
    FETCH_GET_ASSISTANTS: (state) => {
        return {...state, error: null, fetching: true};
    },
    FETCH_GET_ASSISTANTS_FAILED: (state, action) => {
        return {...state, data: null, error: action.payload, fetching: false};
    },
    FETCH_GET_ASSISTANTS_SUCCESS: (state, action) => {
        return {...state, data: action.payload, error: null, fetching: false};
    }
}, initialState);

//- Selectors
export const getAssistants = state => state.assistants;

export const loadingAssistants = state => getAssistants(state).fetching;

export const getAssistantsData = state => getAssistants(state).data;

export const geAssistantsFormattedData = state => {
    let data = getAssistantsData(state);
    if (!data) {
        return null;
    }

    return !data ? null : data.map(assistant => {
        let roles = [];
        if (assistant.permissions.hasFinancialManagerPermission) {
            roles.push(ASSISTANT_TYPES.FINANCIAL_ASSISTANT);
        }
        if (assistant.permissions.hasProcessingManagerPermission) {
            roles.push(ASSISTANT_TYPES.PROCESS_ASSISTANT);
        }
        return {
            id: assistant.id,
            email: assistant.email,
            firstName: assistant.identityAlias.firstName,
            lastName: assistant.identityAlias.lastName,
            countryCode: assistant.identityAlias.countryCode,
            roles: roles,
            hasRootPermission: assistant.permissions.hasRootPermission
        };
    })
};



// WEBPACK FOOTER //
// ./src/reducers/assistant/assistants.js